import React from "react";

import cx from "classnames";

import type { PaneProps } from "~/auth/panes/types";
import { ReactComponent as BlackFellowWordmark } from "~/legacy-assets/images/logos/fellow-wordmark-black-solid.svg";
import { ReactComponent as WhiteFellowWordmark } from "~/legacy-assets/images/logos/fellow-wordmark-white-solid.svg";

import styles from "./MobileHeader.module.css";

export default function MobileHeader({ bgStyle = "dot" }: PaneProps) {
	const Wordmark = bgStyle === "custom" ? WhiteFellowWordmark : BlackFellowWordmark;

	return (
		<div className={cx(styles.mobileHeader, { [styles[bgStyle]]: true })}>
			<div className={styles.mobileWrapper}>
				<h2 className={styles.wordMarkText}>Welcome to</h2>
				<Wordmark className={styles.wordMark} />
			</div>
		</div>
	);
}

export function EmptyHeader(_props: PaneProps) {
	return <></>;
}
